import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 165 169"
      height={props.height ? props.height : "20px"}
      className={props.className}
    >
      <path
        fill={props.color ? props.color : "black"}
        d="M4743.55 4619.01l32.98 32.98a3.766 3.766 0 005.31 0l7.36-7.37a3.736 3.736 0 000-5.3l-32.57-32.57c10.81-12.9 17.31-29.52 17.31-47.64 0-40.98-33.26-74.25-74.24-74.25s-74.25 33.27-74.25 74.25c0 40.97 33.27 74.24 74.25 74.24 16.4 0 31.56-5.32 43.85-14.34zm-43.85-116.23c31.09 0 56.33 25.24 56.33 56.33s-25.24 56.33-56.33 56.33-56.33-25.24-56.33-56.33 25.24-56.33 56.33-56.33z"
        transform="translate(-4625.45 -4484.86)"
      ></path>
    </svg>
  );
}

export default Icon;
